function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0002 17.9091C23.0202 18.6591 22.8202 19.3691 22.4602 19.9791C22.2602 20.3391 21.9902 20.6691 21.6902 20.9391C21.0002 21.5791 20.0902 21.9691 19.0802 21.9991C17.6202 22.0291 16.3302 21.2791 15.6202 20.1291C15.2402 19.5391 15.0102 18.8291 15.0002 18.0791C14.9702 16.8191 15.5302 15.6791 16.4302 14.9291C17.1102 14.3691 17.9702 14.0191 18.9102 13.9991C21.1202 13.9491 22.9502 15.6991 23.0002 17.9091Z",
  stroke: "#94A3B8",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4404 18.0288L18.4504 18.9888L20.5404 16.9688",
  stroke: "#94A3B8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.16992 7.43945L11.9999 12.5494L20.7699 7.46942",
  stroke: "#94A3B8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12 21.6091V12.5391",
  stroke: "#94A3B8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6096 9.17V14.83C21.6096 14.88 21.6096 14.92 21.5996 14.97C20.8996 14.36 19.9996 14 18.9996 14C18.0596 14 17.1896 14.33 16.4996 14.88C15.5796 15.61 14.9996 16.74 14.9996 18C14.9996 18.75 15.2096 19.46 15.5796 20.06C15.6696 20.22 15.7796 20.37 15.8996 20.51L14.0696 21.52C12.9296 22.16 11.0696 22.16 9.92963 21.52L4.58963 18.56C3.37963 17.89 2.38965 16.21 2.38965 14.83V9.17C2.38965 7.79 3.37963 6.11002 4.58963 5.44002L9.92963 2.48C11.0696 1.84 12.9296 1.84 14.0696 2.48L19.4096 5.44002C20.6196 6.11002 21.6096 7.79 21.6096 9.17Z",
  stroke: "#94A3B8",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgBoxTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTick);
export default __webpack_public_path__ + "static/media/box-tick.a9ccfbc1.svg";
export { ForwardRef as ReactComponent };